import { defineMessages } from 'react-intl';

const prefix = 'app.components.PlanningSupportForm';

export default defineMessages({
  openDialogButton: {
    id: `${prefix}.openDialogButton`,
    defaultMessage: 'Automated planning',
  },
  cancel: {
    id: `${prefix}.cancel`,
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: `${prefix}.confirm`,
    defaultMessage: 'Start automated planning',
  },
  description: {
    id: `${prefix}.description`,
    defaultMessage:
      'Start the automated planning by selecting which routes you want to be planned on which day. The planning will be started in the background and may take some minutes to complete. After the planning is complete and further publishers apply, you can trigger the automated planning again to consider the new applications.',
  },
  draftMode: {
    id: `${prefix}.draftMode`,
    defaultMessage: 'Draft mode',
  },
  draftModeDescription: {
    id: `${prefix}.draftModeDescription`,
    defaultMessage:
      "Doesn't actually make any assignments but provides you with an excel file containing the assignments. Use this mode to fine-tune the settings for the automated planning.",
  },
  ignoreExistingPlan: {
    id: `${prefix}.ignoreExistingPlan`,
    defaultMessage: 'Ignore existing assignments',
  },
  ignoreExistingPlanDescription: {
    id: `${prefix}.ignoreExistingPlanDescription`,
    defaultMessage:
      'Use this to compare the generated assignments with the ones I already made',
  },
  isPlanning: {
    id: `${prefix}.isPlanning`,
    defaultMessage: 'Planning in progress...',
  },
  mode: {
    id: `${prefix}.mode`,
    defaultMessage: 'Please select a mode',
  },
  planMode: {
    id: `${prefix}.planMode`,
    defaultMessage: 'Planning mode',
  },
  planModeDescription: {
    id: `${prefix}.planModeDescription`,
    defaultMessage:
      'Automatically assigns publishers according to the route and planning settings. The shifts are left in the "changed" state so you can still check the assignments and make changes if needed.',
  },
  route: {
    id: `${prefix}.route`,
    defaultMessage: 'Please select which routes you want to plan.',
  },
  startPlanningSuccess: {
    id: `${prefix}.startPlanningSuccess`,
    defaultMessage: 'Planning started successfully.',
  },
  startPlanningFailure: {
    id: `${prefix}.startPlanningFailure`,
    defaultMessage: 'Failed to start planning.',
  },
  title: {
    id: `${prefix}.title`,
    defaultMessage: 'Automated planning',
  },
  weekday: {
    id: `${prefix}.weekday`,
    defaultMessage: 'Please select which day you want to plan.',
  },
  wholeWeek: {
    id: `${prefix}.wholeWeek`,
    defaultMessage: 'Whole week',
  },
});
